import { Segment } from "semantic-ui-react";

import React from "react";

export default function PlaceholderSegment({ onClick, ...props }) {
	return (
		<Segment
			placeholder
			textAlign="center"
			style={{
				gap: "1em",
				flexDirection: "row",
				alignItems: "center",
				justifyContent: "center",
				background: "transparent",
				boxShadow: "none",
				padding: 0,
				width: "100%",
				minHeight: 160,
				cursor: onClick ? "pointer" : "default",
				border: "1px dashed rgba(0, 0, 0, 0.12)",
			}}
			onClick={onClick}
			{...props}
		/>
	);
}
